export default __webpack_public_path__ + "static/media/6Baddie.cb43d422.png";